import { CreatePageLayout } from 'framework/ui/layout';
import { useVendorId, useVendorsUrl } from '../routes';
import useVendorService from '../useVendorService';
import ComplianceVendorBreadcrumbs from './ComplianceVendorBreadcrumbs';
import { FormShowTemplate } from 'framework/form';
import ComplianceVendorForm from './ComplianceVendorForm';
import RejectVendorButton from '../shared/buttons/RejectVendorButton';
import { useNavigate } from 'react-router-dom';

const ComplianceVendorPage = () => {
  const id = useVendorId()!;
  const navigate = useNavigate();
  const { getSingleEntityUrl } = useVendorsUrl();
  const { getById, complianceVendor, complianceVendorValidationSchemaFunc } = useVendorService();

  return (
    <FormShowTemplate
      getDataFunc={() => getById(id, true)}
      mapDataForForm={data => {
        // VendorDto
        return {
          ...data,
          isCompliant: true, // Only for form
        };
      }}
      afterSubmit={{
        message: 'You are awesome! The Vendor has been successfully confirmed.',
        execute: () => {
          navigate(getSingleEntityUrl(id));
        },
      }}
      getValidationSchemaFunc={complianceVendorValidationSchemaFunc}
      submitFormFunc={async data => complianceVendor(id, data)}
    >
      <CreatePageLayout
        title="Vendor Сompliance"
        titleActions={<RejectVendorButton />}
        breadcrumbs={<ComplianceVendorBreadcrumbs />}
      >
        <ComplianceVendorForm />
      </CreatePageLayout>
    </FormShowTemplate>
  );
};

export default ComplianceVendorPage;
